import { getApiBaseUrl } from '../config/api';

export type NotificationType =
  | 'NEW_MESSAGE'
  | 'BOOKING_REQUEST_SENT'
  | 'BOOKING_REQUEST_ACCEPTED'
  | 'BOOKING_CAREGIVER_UNAVAILABLE'
  | 'LEARNING_MODULE_COMPLETED'
  | 'CREDENTIAL_SUBMITTED'
  | 'CREDENTIAL_ACCEPTED'
  | 'CREDENTIAL_REJECTED'
  | 'CREDENTIAL_RENEWAL_REMINDER'
  | 'CREDENTIAL_EXPIRED';

export type NotificationDeliveryStatus = 'PENDING' | 'DELIVERED' | 'FAILED';

export interface NotificationEvent {
  id: string;
  recipientId: string;
  actorId: string | null;
  type: NotificationType;
  title: string;
  body: string;
  metadata: Record<string, unknown> | null;
  status: NotificationDeliveryStatus;
  deliveredAt: string | null;
  createdAt: string;
  updatedAt: string;
}

class NotificationsService {
  private getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async getMyNotifications(): Promise<NotificationEvent[]> {
    const baseUrl = await getApiBaseUrl();
    const response = await fetch(`${baseUrl}/notifications/my`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch notification feed');
    }

    const result = await response.json();
    return result.data;
  }
}

export const notificationsService = new NotificationsService();
